export default "__VITE_ASSET__DFWNimRn__"